import React from "react";
import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/account";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-ivory">
      <div className="hidden lg:block relative bg-espresso">
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/luxyreign/brand/owner-7bc9fdcd.jpeg`}
          alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-pitch/70 to-pitch/10" />
        <div className="absolute bottom-14 left-14 right-14">
          <Link to="/" className="font-serif text-3xl tracking-[0.3em] text-ivory">LUXYREIGN</Link>
          <p className="text-ivory/70 mt-4 max-w-sm font-light leading-relaxed">Curated pre-owned luxury pieces, selected for those who appreciate enduring style.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16 sm:px-12">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden font-serif text-2xl tracking-[0.3em] text-pitch block text-center mb-10">LUXYREIGN</Link>
          <p className="eyebrow mb-3">{subtitle}</p>
          <h1 className="font-serif text-4xl text-pitch tracking-tight mb-8">{title}</h1>
          {children}
          {footer && <div className="mt-8 text-sm text-center text-stonemuted">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
